import React, { useState } from 'react'
import { Button, Tooltip } from 'antd'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faComments } from '@fortawesome/free-solid-svg-icons'
import ChatPopup from './components/ChatPopup'

const GeneralChatbot = ({ assistantId, JSONContext }) => {
  const [isChatOpen, setIsChatOpen] = useState(false)

  const handleOpenChat = () => {
    setIsChatOpen(true)
  }

  const handleCloseChat = () => {
    setIsChatOpen(false)
  }

  return (
    <div>
      {/* Chat Button */}
      {!isChatOpen && (
        <Tooltip title='Open AI Assistant'>
          <Button
            type='primary'
            icon={<FontAwesomeIcon icon={faComments} />}
            onClick={handleOpenChat}
            style={{
              position: 'fixed',
              bottom: 20,
              right: 20,
              borderRadius: 28,
              display: 'flex',
              alignItems: 'center'
            }}
          >
            Chat with AI
          </Button>
        </Tooltip>
      )}

      {/* Chat Popup */}
      {isChatOpen && <ChatPopup assistantId={assistantId} onClose={handleCloseChat} JSONContext={JSONContext} />}
    </div>
  )
}

export default GeneralChatbot
